import { useParams } from "react-router-dom";
import "react-alice-carousel/lib/alice-carousel.css";
import GetProjects from "../firebase/fetchDB";

const Project = () => {
  const { projects, isPending } = GetProjects();
  const { id } = useParams();
  const project = projects.find((proj, i) => id.toString() === i.toString());
  console.log(id);
  console.log(project);
  return (
    <div className="project-details">
      {isPending && <h1>LOADING...</h1>}
      {project && (
        <div>
          <div className="project-icontitle">
            {project.icon && (
              <img src={project.icon} width={"100em"} alt="projectIcon" />
            )}
            <div className="project-title">
              <div></div>
              <h1>{project.title}</h1>
              <h6>{project.shortDesc}</h6>
            </div>
          </div>
          {project.images && (
            <div className="divImage">
              {project.images.map((image) => (
                <img
                  className="imageTitle"
                  alt="screenshot/project"
                  src={image}
                />
              ))}
            </div>
          )}
          <div className="project-data">
            {project.features && (
              <div className="project-features">
                <h2>Features:</h2>
                {project.features.map((feature) => (
                  <p>{feature}</p>
                ))}
              </div>
            )}
            <div className="project-desc">
              <h2>Description:</h2>
              <p>{project.desc}</p>
            </div>
            {project.category === "android" && project.accessLink && (
              <div className="downloadLink">
                <a href={project.accessLink}>
                  <img
                    src="/images\google-play-badge.png"
                    alt="Google-Play Download"
                  />
                </a>
              </div>
            )}
            {project.github && (
              <div className="downloadLink">
                <a href={project.github}>
                  <img src="\images\github.png" alt="Github Link" />
                </a>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Project;
